import axiosPlugin from './src/axios'

export default {
  options: {
    axios: {}
  },
  install(Vue, options = {}) {
    let opts = Object.assign({}, this.options, options)

    // 安装axios，可选
    if (opts.axios !== false) {
      Vue.use(axiosPlugin, opts.axios)
    }
  }
}



// WEBPACK FOOTER //
// ./src/packages/plugins/index.js